export default "/assets/website/images/hero_valentin.jpg?3f79cc3ef848fc494b156aee1829aabf";